import { GET_ALL_FACILIYS } from '../../types'

const INITIAL_STATE = {
  getAllFacilitys: [],
}

const facilityReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_FACILIYS:
      return {
        ...state,
        getAllFacilitys: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default facilityReducer
